export const PLAN_SCOPES = ['pro', 'premium'];
export const PLAN_VERSIONS = ['initial', 'Q3-2024'];